import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  LOAD_COUPON_SECTORS,
  LOAD_COUPON_SECTORS_SUCCESS,
  LOAD_COUPON_SECTORS_FAIL,
} from "../actions/couponSectors";

const initialState = {
  couponSectors: [],
  couponSectorsById: {},
};

export default function couponSectors(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_COUPON_SECTORS:
      return {
        ...state,
        isLoading: true,
      }

    case LOAD_COUPON_SECTORS_SUCCESS:
      const couponSectors = action.response.couponSector.map(item => ({
        ...item,
        id: +item.id,
        title: item.name,
        value: +item.id
      })) || [];
      const couponSectorsById = mapObjectize(couponSectors);
      return {
        ...state,
        couponSectors: mapIds(couponSectors),
        couponSectorsById,
        isLoading: false,
        isLoaded: true,
      }

    case LOAD_COUPON_SECTORS_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
      }

    default:
      return state;
  }
}
